import { render, staticRenderFns } from "./zb-transfer.vue?vue&type=template&id=54957721&scoped=true&"
import script from "./zb-transfer.vue?vue&type=script&lang=js&"
export * from "./zb-transfer.vue?vue&type=script&lang=js&"
import style0 from "./zb-transfer.vue?vue&type=style&index=0&id=54957721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54957721",
  null
  
)

export default component.exports